import PhotoWrapper from '../src/PhotoWrapper';
export default PhotoWrapper;
